export const isAbsoluteUrl = (url) => /^([a-z]+:)?\/\//.test(url);
